import {
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    AccordionIcon,
    Box,
    useColorModeValue,
    Text,
    MenuItem,
    Icon,
    Button,
    Flex,
    Spinner
} from '@chakra-ui/react';
import { AnimatePresence, motion } from 'framer-motion';
import { useEffect, useMemo, useState } from 'react';
import { ChevronDownSmallIcon } from '../../platformFiles/extensionSpecific/ActiveTabGroup';
import usePersistStore from '../stores/persistStore';
import useStore from '../stores/store';
import { group } from 'console';

export const MoveActiveTabAccordion = ({ id, closeAfterMove }) => {
    const [menuOpen, setMenuOpen] = useState(null);
    const categories = useStore((state) => state.categories);
    const tabGroups = useStore.getState().tabGroups;
    const currentWsId = useStore.getState().currentWsId;

    const onMove = (groupId) => {
        useStore.getState().saveActiveTab(id, groupId);
        closeAfterMove();
    };

    return (
        <>
            {categories.map((cat, catIndex) => (
                <MoveAccordion
                    key={catIndex}
                    symbol={null}
                    name={cat.name}
                    id={cat.id}
                    menuOpen={menuOpen}
                    setMenuOpen={setMenuOpen}
                    fontW={600}
                >
                    {tabGroups
                        .filter((group) => group.categoryID === cat.id)
                        .map((group, index) => (
                            <AnimatedMoveRow
                                key={index}
                                title={group.title}
                                icon={group.emoji}
                                onItemClick={() => onMove(group.id)}
                            />
                        ))}
                </MoveAccordion>
            ))}
        </>
    );
};

export const MoveGroupToAccordion = ({ groupId, closeGroupMenu }) => {
    const [menuOpen, setMenuOpen] = useState(null);
    const workspaces = useStore.getState().userData.workspaces;
    const currentWsId = useStore.getState().currentWsId;
    const selectedCategory = usePersistStore.getState().selectedCategory;
    //create a array so that the current workspace is first
    const orderedWs = useMemo(() => {
        let currentWs = null;
        const otherWs = [];

        for (const ws of workspaces) {
            if (ws.id === currentWsId) {
                // Create a copy of currentWs before modifying its catData
                currentWs = { ...ws, catData: [...ws.catData] };
                if (
                    currentWs.catData &&
                    selectedCategory < currentWs.catData.length
                ) {
                    currentWs.catData.splice(selectedCategory, 1);
                }
            } else {
                otherWs.push(ws);
            }
        }

        return currentWs ? [currentWs, ...otherWs] : otherWs;
    }, [workspaces, currentWsId, selectedCategory]);

    const onMove = (wsId, catId, catName) => {
        useStore.getState().moveGroupData(groupId, wsId, catId, catName);
        closeGroupMenu();
    };

    return (
        <>
            {orderedWs.map((ws, index) => (
                <MoveAccordion
                    key={index}
                    symbol={ws.emoji}
                    name={ws.name}
                    id={ws.id}
                    menuOpen={menuOpen}
                    setMenuOpen={setMenuOpen}
                    isCurrent={index === 0}
                    //isDisabled={!ws.catData?.length}
                >
                    {ws.catData?.length ? (
                        ws.catData.map((cat, index) => (
                            <AnimatedMoveRow
                                key={index}
                                title={cat.name}
                                onItemClick={() =>
                                    onMove(ws.id, cat.id, cat.name)
                                }
                            />
                        ))
                    ) : (
                        <Box p="8px 4px 8px 12px" cursor={'secondaryText'}>
                            <Text
                                fontWeight={500}
                                opacity={0.6}
                                my="auto"
                                color="catText"
                            >
                                No other categories
                            </Text>
                        </Box>
                    )}
                </MoveAccordion>
            ))}
        </>
    );
};

export const MoveItemToAccordion = ({ tabId, closeSiteModal }) => {
    const [menuOpen, setMenuOpen] = useState(null);
    const [catOpen, setCatOpen] = useState(null);

    const workspaces = useStore.getState().userData.workspaces;
    const currentWsId = useStore.getState().currentWsId;
    const selectedCategory = usePersistStore.getState().selectedCategory;
    //create a array so that the current workspace is first
    const orderedWs = useMemo(() => {
        let currentWs = null;
        const otherWs = [];

        for (const ws of workspaces) {
            if (ws.id === currentWsId) {
                // Create a copy of currentWs before modifying its catData
                currentWs = { ...ws, catData: [...ws.catData] };
                if (
                    currentWs.catData &&
                    selectedCategory < currentWs.catData.length
                ) {
                    currentWs.catData.splice(selectedCategory, 1);
                }
            } else {
                otherWs.push(ws);
            }
        }

        return currentWs ? [currentWs, ...otherWs] : otherWs;
    }, [workspaces, currentWsId, selectedCategory]);

    return (
        <>
            {orderedWs.map((ws, wsIndex) => (
                <MoveAccordion
                    key={wsIndex}
                    symbol={ws.emoji}
                    name={ws.name}
                    id={ws.id}
                    menuOpen={menuOpen}
                    setMenuOpen={setMenuOpen}
                    fontW={600}
                    isCurrent={wsIndex === 0}
                >
                    {ws.catData?.map((cat, catIndex) => (
                        <MoveAccordion
                            key={catIndex}
                            symbol={null}
                            name={cat.name}
                            id={cat.id}
                            menuOpen={catOpen}
                            setMenuOpen={setCatOpen}
                            fontW={600}
                        >
                            <GroupsToChooseInCat
                                isCurrent={wsIndex === 0}
                                wsId={ws.id}
                                catId={cat.id}
                                tabId={tabId}
                                closeSiteModal={closeSiteModal}
                            />
                        </MoveAccordion>
                    ))}
                </MoveAccordion>
            ))}
        </>
    );
};

const GroupsToChooseInCat = ({
    isCurrent,
    wsId,
    catId,
    tabId,
    closeSiteModal
}) => {
    const [isLoading, setIsLoading] = useState(true);
    const [groupsInCat, setGroupsInCat] = useState([]);
    const cachedGroup = useStore((state) => state.cachedGroups[wsId]);
    useEffect(() => {
        if (isCurrent) {
            //We already haff data
            let groups = useStore.getState().tabGroups.filter((group) => {
                return group.categoryID === catId;
            });
            setGroupsInCat(groups);
            setIsLoading(false);
        } else {
            if (!cachedGroup) {
                useStore.getState().hydrateCachedGroups(wsId);
            } else if (cachedGroup === 'loading') {
            } else {
                let groups = cachedGroup.tabData.filter((group) => {
                    return group.categoryID === catId;
                });
                setGroupsInCat(groups);
                setIsLoading(false);
            }
        }
    }, [cachedGroup]);

    if (isLoading)
        return (
            <Flex h="36px" alignItems="center" px="12px">
                <Spinner size="sm" color="blue.300" speed={'0.32s'} my="auto" />
            </Flex>
        );

    if (groupsInCat.length === 0)
        return (
            <Flex h="36px" alignItems="center" px="12px">
                <Text opacity={0.4} fontSize="14px" fontWeight={600} my="auto">
                    Empty category
                </Text>
            </Flex>
        );

    const onMove = (groupId) => {
        useStore.getState().moveTabToGroup(tabId, wsId, groupId);
        closeSiteModal();
    };

    return (
        <>
            {groupsInCat.map((g, index) => (
                <AnimatedMoveRow
                    key={index}
                    title={g.title}
                    icon={g.emoji}
                    onItemClick={() => onMove(g.id)}
                />
            ))}
        </>
    );
};

export const MoveAccordion = ({
    id,
    menuOpen,
    setMenuOpen,
    symbol,
    name,
    fontW = 500,
    isDisabled = false,
    children,
    isCurrent = false
}) => {
    const menuBg = useColorModeValue('#FFF', '#262A2D');
    const lightBg = useColorModeValue('gray.50', '#31363a');
    const deleteBg = useColorModeValue('red.100', '#552F32');
    const buttonHoverBg = useColorModeValue('gray.100', '#FFFFFF20');
    const buttonActiveBg = useColorModeValue('gray.200', '#FFFFFF10');

    const accProps = {
        display: 'flex',
        alignItems: 'center',
        bg: { menuBg },
        p: '8px 12px 8px 12px',
        rounded: '6px',
        fontWeight: 500,
        transition: '0.05s',
        //margin: '4px',
        _hover: { bg: lightBg },
        iconSpacing: '12px'
    };

    //const [mainOpen, setMainOpen] = useState(false);
    const toggleMain = () => setMenuOpen(menuOpen === id ? null : id);
    const isNotOpen = menuOpen && menuOpen !== id;

    return (
        <>
            <MenuItem
                opacity={isNotOpen ? 0.625 : 1}
                filter={isNotOpen ? 'blur(2px)' : ''}
                icon={
                    !symbol ? null : symbol === 'moveIcon' ? (
                        <TwoArrowsIcon />
                    ) : symbol?.length > 10 ? (
                        <img
                            src={symbol}
                            height="16px"
                            width="16px"
                            style={{
                                overflow: 'hidden',
                                borderRadius: '1px'
                            }}
                        />
                    ) : (
                        <span>{symbol}</span>
                    )
                }
                {...accProps}
                onClick={toggleMain}
                closeOnSelect={false}
                maxH="38px"
                zIndex={5}
                isDisabled={isDisabled}
                pos="relative"
                isTruncated
                /* filter={
                    menuOpen !== null && menuOpen !== id
                        ? 'blur(2px)'
                        : 'blur(0)'
                } */
            >
                <Flex alignItems="center" flex="1">
                    {/* {isCurrent && (
                        <Box
                            pos="absolute"
                            left="-1px"
                            top="11px"
                            h="16px"
                            w="3px"
                            rounded="3px"
                            bg={
                                'linear-gradient(145deg, #5DABFE 0%, #3391FF 100%)'
                            }
                        />
                    )} */}
                    <Text
                        my="auto"
                        fontWeight={fontW}
                        //color={isCurrent ? '#3095FF' : 'inherit'}
                    >
                        {name}
                    </Text>
                    <motion.div
                        animate={{
                            rotate: menuOpen === id ? 180 : 0
                        }}
                        style={{ marginLeft: 'auto' }}
                        /* onAnimationStart={(dir) =>
                                        chevronFlip(dir, 'start')
                                    }
                                    onAnimationComplete={(dir) =>
                                        chevronFlip(dir, 'complete')
                                    } */
                    >
                        <Icon as={ChevronDownSmallIcon} boxSize={2} />
                    </motion.div>
                </Flex>
            </MenuItem>
            <AnimatePresence initial={false}>
                {menuOpen === id && (
                    <motion.section
                        key="content"
                        initial="collapsed"
                        animate="open"
                        exit="collapsed"
                        variants={{
                            open: { opacity: 1, height: 'auto' },
                            collapsed: { opacity: 0, height: 0 }
                        }}
                        transition={{
                            duration: 0.12
                        }}
                    >
                        <motion.div
                            variants={{
                                collapsed: { opacity: 0, y: -4 },
                                open: {
                                    opacity: 1,
                                    y: 0,
                                    transition: { delay: 0.04 }
                                }
                            }}
                            transition={{ duration: 0.12 }}
                        >
                            {/* <MenuItem {...accProps}>Content</MenuItem> */}
                            {children}
                        </motion.div>
                    </motion.section>
                )}
            </AnimatePresence>
        </>
    );
};

export const AnimatedMoveRow = ({ title, onItemClick, icon = null }) => {
    const menuBg = useColorModeValue('#FFF', '#262A2D');
    const lightBg = useColorModeValue('gray.50', '#31363a');
    const accProps = {
        display: 'flex',
        alignItems: 'center',
        bg: { menuBg },
        padding: 0,
        rounded: '6px',
        fontWeight: 500,
        transition: '0.05s',
        //margin: '4px',
        _hover: {
            bg: 'rgb(65, 225, 139, 0.1)',
            boxShadow: '0 0 0 2px #41E18B'
        },
        iconSpacing: '12px',
        overflow: 'hidden'
    };

    return (
        <MenuItem pos="relative" {...accProps} onClick={onItemClick} zIndex={4}>
            <motion.div
                style={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    padding: '8px 4px 8px 12px'
                }}
                whileHover="hover"
            >
                <ArrowBubbleRight />
                <motion.div
                    variants={{ hover: { x: 28 } }}
                    style={{
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        maxWidth: '100%',
                        fontSize: '14px',
                        display: 'flex'
                    }}
                    transition={{ duration: 0.18, ease: 'easeOut' }}
                >
                    {icon ? (
                        icon?.length > 10 ? (
                            <img
                                src={icon}
                                height="16px"
                                width="16px"
                                style={{
                                    overflow: 'hidden',
                                    borderRadius: '1px',
                                    marginRight: '8px'
                                }}
                            />
                        ) : (
                            <span style={{ marginRight: '8px' }}>{icon}</span>
                        )
                    ) : null}
                    {title ? title : 'Untitled'}
                </motion.div>
            </motion.div>
        </MenuItem>
    );
};

export const TwoArrowsIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            viewBox="0 0 20 20"
            fill="var(--chakra-colors-iconMd)"
            style={{
                width: '16px',
                height: '16px'
            }}
        >
            <path d="M8 5a1 1 0 100 2h5.586l-1.293 1.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L13.586 5H8zM12 15a1 1 0 100-2H6.414l1.293-1.293a1 1 0 10-1.414-1.414l-3 3a1 1 0 000 1.414l3 3a1 1 0 001.414-1.414L6.414 15H12z" />
        </svg>
    );
};

export const SortByIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            viewBox="0 0 20 20"
            fill="var(--chakra-colors-iconMd)"
            style={{
                width: '16px',
                height: '16px'
            }}
        >
            <path d="M3 3a1 1 0 000 2h11a1 1 0 100-2H3zM3 7a1 1 0 000 2h5a1 1 0 000-2H3zM3 11a1 1 0 100 2h4a1 1 0 100-2H3zM13 16a1 1 0 102 0v-5.586l1.293 1.293a1 1 0 001.414-1.414l-3-3a1 1 0 00-1.414 0l-3 3a1 1 0 101.414 1.414L13 10.414V16z" />
        </svg>
    );
};

export const SortAlaphabeticalIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            viewBox="0 0 20 20"
            style={{
                width: '16px',
                height: '16px'
            }}
            fill="var(--chakra-colors-iconMd)"
        >
            <text x="5" y="15" style={{ fontWeight: '700' }}>
                AZ
            </text>
        </svg>
    );
};

export const SortTimeIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            viewBox="0 0 20 20"
            style={{
                width: '16px',
                height: '16px'
            }}
            fill="var(--chakra-colors-iconMd)"
        >
            <text x="5" y="15">
                00
            </text>
        </svg>
    );
};

const ArrowBubbleRight = () => {
    return (
        <motion.svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            viewBox="0 0 20 20"
            style={{
                width: '20px',
                height: '20px',
                position: 'absolute',
                left: 10,
                top: 10
            }}
            initial={{ scale: 0, opacity: 0 }}
            variants={{
                hover: {
                    opacity: 1,
                    scale: 1
                    /* transition: {
                        duration: 0.3,
                        ease: [0.175, 0.885, 0.32, 1.275]
                    } */
                }
            }}
            //exit={{ scale: 0, transition: { duration: 0.1, delay: 0 }}
        >
            <path
                fill="#41E18B"
                fillRule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 1.414L10.586 9H7a1 1 0 100 2h3.586l-1.293 1.293a1 1 0 101.414 1.414l3-3a1 1 0 000-1.414z"
                clipRule="evenodd"
            />
        </motion.svg>
    );
};
